import React from 'react';
import { Container, Divider, Icon, Paper, Tab, Tabs, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { TaskLists, TaskListRules } from '../../components';

const TasksPage: React.FC = () => {
  const { option } = useParams<{ option: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/tasks/lists');
        break;
      case 1:
        navigate('/tasks/rules');
        break;
      default:
        break;
    }
  };

  const getTabIndex = (): number => {
    if (option && option === 'lists') {
      return 0;
    }
    if (option && option === 'rules') {
      return 1;
    }
    return 0;
  };

  React.useEffect(() => {
    const tabIndex = getTabIndex();
    setTab(tabIndex);
  }, [option]);

  const [tab, setTab] = React.useState(getTabIndex());

  return (
    // 1280px is v4's lg, which this page was laid out against; v9's lg is 1200px.
    <Container maxWidth={false} sx={{ maxWidth: 1280 }}>
      {/* v4's layout, kept: a spacing-2 grid pulled 8px out, its one cell padded 8px. */}
      <div className="-m-2 box-border flex w-[calc(100%+16px)] flex-wrap">
        <div className="box-border w-full p-2">
          <div className="box-border flex w-full flex-wrap">
            <div className="-m-1 box-border flex w-[calc(100%+8px)] flex-wrap min-[960px]:w-4/12">
              <div className="box-border p-1">
                <Icon fontSize="large" color="primary">
                  {'list'}
                </Icon>
              </div>
              <div className="box-border p-1">
                <Typography component="h2" variant="h6" color="primary">
                  {t('f-tasks')}
                </Typography>
              </div>
            </div>
          </div>

          <div className="mt-2 box-border flex w-full flex-col">
            <Tabs value={tab} onChange={handleTabChange}>
              <Tab label={t('f-tasks-lists')} id="listsTab" />
              <Tab label={t('f-tasks-rules')} id="rulesTab" />
            </Tabs>
            <Divider />
          </div>

          <Paper
            elevation={1}
            sx={{ p: 2, display: 'flex', overflow: 'auto', flexDirection: 'column', minHeight: 200 }}
          >
            <div className="box-border flex w-full flex-wrap">
              {tab === 0 && (
                <div className="box-border w-full">
                  <TaskLists />
                </div>
              )}
              {tab === 1 && (
                <div className="box-border w-full">
                  <TaskListRules />
                </div>
              )}
            </div>
          </Paper>
        </div>
      </div>
    </Container>
  );
};

export default TasksPage;
